import React from "react";

export const FormHeader = ({ label }) => {
  return <div className="lf-form-header">{label}</div>;
};

